import 'bootstrap-loader';
import 'nvd3/build/nv.d3.css';
import './styles/main.scss';

import * as angular from 'angular';
import * as _ from 'lodash';
import '@uirouter/angularjs';
import 'angular-sanitize';
import 'angular-animate';
import 'angular-messages';
import 'angular-ui-bootstrap';
import 'angular-ui-router-title';
import 'snapsvg-cjs/dist/snap.svg-cjs.js';
import 'moment/moment';
import 'angular-local-storage';

import 'd3';
import 'nvd3';
import 'angular-nvd3';

var ciApp = angular.module('ciApp', [
  'ui.router',
  'ui.router.title',
  'ngSanitize',
  'ngAnimate',
  'ngMessages',
  'ui.bootstrap',
  'ciApp.routes',
  'ciApp.services',
  'LocalStorageModule',
  'nvd3'
]);

angular.module('ciApp.services', ['LocalStorageModule']);

// TODO: See if we can not do this (require)... :thinking_face:
// ES6 Imports will hoist, and we depend on modules being defined before doing this...
require('./common/services');
require('./common/models');
require('./common/components');
require('./common/filters');
require('./common/constants');
require('./routes');

require('./app/noRoute/noRoute.component');
require('./app/login/login.component');
require('./app/logout/logout.component');
require('./app/denied/denied.component');
require('./app/epx/epx.component');
require('./app/admin/admin.component');

ciApp
  .config([
    '$httpProvider',
    '$qProvider',
    function($httpProvider, $qProvider) {
      $qProvider.errorOnUnhandledRejections(false);

      // Trigger spinner on all HTTP requests
      $httpProvider.interceptors.push([
        'Notify',
        'SpinnerService',
        'localStorageService',
        '$state',
        '$injector',
        function(Notify, SpinnerService, localStorageService, $state, $injector) {
          return {
            request: function(config) {
              SpinnerService.start();
              return config;
            },

            response: function(response) {
              SpinnerService.stop();
              return response;
            },
            responseError: function(error) {
              SpinnerService.stop();

              if (_.get(error, 'config.cancel.promise.$$state.status') > 0) {
                // Service call was canceled. Don't treat it like an error
                return;
              }
              if (error.status == 401) {
                // Manually inject AuthService to get around the circular dependency
                var AuthService = $injector.get('AuthService');
                AuthService.logout();
                $state.go('login');
                return;
              }
              Notify.error(diagnoseHttp(error));
              throw error;
            }
          };
        }
      ]);
    }
  ])
  .constant('apiUrl', process.env.API_LOCATION)
  .constant('classicUrl', process.env.CLASSIC_CLIENT_LOCATION)
  .constant('ivxBrochureUrl', 'https://s3.amazonaws.com/cleanlogix-manuals/ivx/IVX%20Brochure.pdf')
  .run([
    '$rootScope',
    '$http',
    '$transitions',
    '$state',
    '$location',
    'SpinnerService',
    'AuthorizeRouteService',
    'AuthService',
    function(
      $rootScope,
      $http,
      $transitions,
      $state,
      $location,
      SpinnerService,
      AuthorizeRouteService,
      AuthService
    ) {
      $rootScope.$on('$stateChangeError', console.log.bind(console));

      // keep user logged in after page refresh
      var user = AuthService.currentUser();
      if (AuthService.isLoggedIn()) {
        $http.defaults.headers.common.Authorization = user.token;
      }

      $transitions.onStart({}, function(trans) {
        SpinnerService.start();
        if (trans.to().name == 'login' && AuthService.isLoggedIn()) {
          var token = $location.search()['auth-token'];

          if (token) {
            AuthService.logout();
          } else {
            SpinnerService.stop();
            AuthService.goHome();
            return;
          }
        }

        angular.forEach($http.pendingRequests, request => {
          if (request.cancel) {
            request.cancel.resolve();
          }
        });
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      });

      $transitions.onFinish({}, () => SpinnerService.stop());

      $transitions.onError({}, () => SpinnerService.stop());
    }
  ]);

function diagnoseHttp(error) {
  let message;

  switch (error.status) {
    case -1:
      message = 'We were unable to reach the server';
      break;
    default:
      let action = error.config.method === 'GET' ? 'retrieving' : 'saving';
      let firstError = _.first(_.get(error, 'data.errors'));
      let errorDescription = _.get(firstError, 'detail');
      message = 'An error occurred ' + action + ' your data: "' + errorDescription + '"';
  }

  return message;
}



// WEBPACK FOOTER //
// ./app.ts